import { z } from "zod";
import { values } from "lodash";
import { sections as HealthSurveillanceQuestionnaireSections } from "@teamprevent/common/healthSurveillance/questionnaire";

import { sections as HealthSurveillanceConsultationSections } from "../healthSurveillance/consultation";

type HealthSurveillanceQuestionnaireSectionId = (typeof HealthSurveillanceQuestionnaireSections)[keyof typeof HealthSurveillanceQuestionnaireSections]["id"];
const questionnaireSectionOptions = values(HealthSurveillanceQuestionnaireSections)
    .map(section => section.id) as [HealthSurveillanceQuestionnaireSectionId, ...HealthSurveillanceQuestionnaireSectionId[]];

type HealthSurveillanceConsultationSectionId = (typeof HealthSurveillanceConsultationSections)[keyof typeof HealthSurveillanceConsultationSections]["id"];
const consultationSectionOptions = values(HealthSurveillanceConsultationSections)
    .map(section => section.id) as [HealthSurveillanceConsultationSectionId, ...HealthSurveillanceConsultationSectionId[]];

export const customMedicalTypeSchema = z.object({
    name: z.string({ required_error: "Name is required" }).min(1, { message: "Name is required" }),
    questionnaireSectionIds: z.array(
        z.enum(questionnaireSectionOptions),
        { required_error: "At least one Questionnaire Section is required" }).min(1, { message: "At least one Questionnaire Section is required" }),
    consultationSectionIds: z.array(
        z.enum(consultationSectionOptions),
        { required_error: "At least one Consultation Section is required" }).min(1, { message: "At least one Consultation Section is required" })
});

export type CustomMedicalTypeFormModel = z.infer<typeof customMedicalTypeSchema>;
